import 'Generic/styles/style.css';
import './styles/style.css';
import {store, setState, fieldsValidation, GpayGateway, ApplePayGateway, constant, GenerateProducts} from 'Generic';
import Gateways from './components/gateways';
import OrderSummary from './components/orderSummary';
import CheckoutForm from './components/checkoutForm';
import Incentive from './components/incentive';
import GatewayIncentive from './components/gatewayIncentive';
import {
  getGpayOnGatewayChange,
  addAddon,
  selectPlan,
  removeAddon,
  applyCouponCode,
  removeCouponCode,
  showCouponResponcse,
  splitIntoFirstAndSecondName,
  selectGateway,
  removeInputError,
  getSelectedGatewayOnLoad,
  addClass,
  removeClass,
  resetPaymentAndIncentive,
  GA4addPaymentInfoEvent,
  sendGa4CustomEvent,
  gmailDomainCorrection,
  openCustomModal,
} from 'Generic/lib';
import 'Generic/lib/tweet';

/* Setting Global Variables */
window.recurlyCardFields.recurlyCardNumber = '0000  0000  0000  0000';
window.base_url = window.location.origin;
window.conditionalGateways = {
  applepay: false,
  gatepay:
    (/android/i.test(navigator.userAgent) && 'gateio' in window) || //to show gatepay in android app
    (['iPad', 'iPhone'].includes(navigator?.userAgentData?.platform || navigator?.platform) &&
      typeof window.webkit?.messageHandlers?.gatepay === 'object'), //to show gatepay in iOS opp
};
window.applePay = {};
window.renderComponents = renderComponents;

/* Cart State */
let cartState = store.state.cartState ? store.state.cartState : {};

/* Parsing cart params data */
let keysToBeParsed = [
  'plans',
  'plans_currency',
  'old_prices',
  'special_addons_old_prices',
  'gateway_incentives',
  'hidden_packages_currency',
  'hidden_packages',
  'hidden_packages_currency',
  'hidden_products_association',
];
let parsedData = {};
keysToBeParsed.map(key => {
  let stateData = cartState[key];
  if (stateData) {
    parsedData = {...parsedData, [key]: JSON.parse(stateData)};
  }
});
setState(parsedData);

/* Setting usefull data in variables to reuse */
let activeTab = document.querySelector('.plan-tabs-wrap li.active');
let planCount = activeTab?.getAttribute('data-plan-index')?.split(',');
let selectedPlanIndex = planCount?.length === 3 ? 1 : 0;
let selectedPlan = cartState.plans[selectedPlanIndex] ? cartState.plans[selectedPlanIndex] : {};
setState({selected_plan: selectedPlan, proplan_index: planCount?.length === 3 ? '1' : '0'});

/* Adding selected gateway in state */
if (cartState) {
  let selectedGateway = getSelectedGatewayOnLoad();
  if (selectedGateway.gateway_key) {
    setState({
      selected_gateway: selectedGateway.gateway_key,
      selected_gateway_name: selectedGateway.gateway_name,
    });
  }
}

/* Cart package boxes select event */
document.querySelectorAll('.cart-box').forEach((cartBox, index) => {
  cartBox?.addEventListener('click', () => {
    resetPaymentAndIncentive();

    let tabElement = cartBox.getAttribute('data-tab-code');
    addClass(`.plan-tabs-wrap ul [data-tabs="${tabElement}"]`, 'active');
    const proplan_index = cartBox.getAttribute('data-key');

    let newSelectedPlan = cartState.plans[index] ? cartState.plans[index] : {};
    if (newSelectedPlan.code !== cartState.selected_plan.code) {
      selectPlan(index, {proplan_index, proplan_code: null});
    }
  });
});

/* Cart gateway select event */
let gatewaysWrapper = document.querySelector('#payment_gateways');
let incentiveElement = document.querySelector('#hidden-product-wrapper');
gatewaysWrapper?.addEventListener('click', function (e) {
  let target = e.target;
  if (target.matches('.payment_selection_box, .payment_selection_box *')) {
    e.stopPropagation();

    let gatewayKey = target.getAttribute('data-name');
    let gatewayName = target.getAttribute('data-gateway-text');
    if (!gatewayKey) {
      gatewayKey = target.closest('.payment_selection_box').getAttribute('data-name');
      gatewayName = target.closest('.payment_selection_box').getAttribute('data-gateway-text');
    }
    if (incentiveElement) {
      incentiveElement.style.display = 'none';
    }

    selectGateway(gatewayKey, gatewayName);
    getGpayOnGatewayChange(gatewayKey, GatewaysInstance);
  }
});

/* Coupon Events */
let couponToggle = document.getElementById('coupon-toggle');
couponToggle.addEventListener('click', () => {
  document.querySelector('.payment-coupon-box').classList.toggle('active');
  document.querySelector('#coupon-input').focus();
});

function applyCouponSubmit() {
  let couponInputValue = document.querySelector('#coupon-input').value;
  if (couponInputValue !== '') {
    if (!couponInputValue.includes('fpdr')) {
      applyCouponCode(couponInputValue);
    } else {
      showCouponResponcse(false);
    }
  }
}

let couponSubmitButton = document.getElementById('coupon-submit');
couponSubmitButton.addEventListener('click', applyCouponSubmit);

let couponRemoveButton = document.querySelector('.payment-coupon-cancel');
couponRemoveButton.addEventListener('click', removeCouponCode);

let couponInputField = document.querySelector('#coupon-input');
couponInputField.addEventListener('focusout', e => {
  let couponValue = e.target.value;
  if (!couponValue) removeCouponCode();
});

couponInputField.addEventListener('keypress', e => {
  if (e.which == 13) {
    e.preventDefault();
    applyCouponSubmit();
  }
});

/* Show password event */
let showPasswordButton = document?.querySelector('.password-eye-icon');
showPasswordButton?.addEventListener('click', () => {
  let passwordInputField = document?.querySelector('#input_password');
  let type = passwordInputField.type === 'text' ? 'password' : 'text';

  passwordInputField.type = type;
});

/* Addon select event */
document.addEventListener('click', function (e) {
  let target = e.target;

  let popupCheck = false;

  /* Addon information popup button click listener */
  if (target.matches('.popup_link, .popup_link *')) {
    e.stopPropagation();
    popupCheck = true;

    let addonCode = target.getAttribute('addon-code');

    if (!addonCode) {
      addonCode = target.closest('.popup_link').getAttribute('addon-code');
    }

    let addonHttml = document.querySelector(`#${addonCode}_info_popup`);

    const modalId = `customcartPopup_${addonCode}`;

    let modalHtmlContent = addonHttml.innerHTML;

    openCustomModal(modalHtmlContent, modalId, 'modalAddonInfoClass');
  }
});

/* Pre select addon logic */
const {addons: selectedPlanAddons} = selectedPlan;
let {pre_selected_addon: preSelectedAddon} = cartState;
/*Split Pre Select addon*/
preSelectedAddon = preSelectedAddon.split(',');

for (let addon of selectedPlanAddons) {
  /* Normal addons */
  if (!constant.specialAddonList.includes(addon.code) && preSelectedAddon.includes(addon.code)) {
    /* If addon has country */
    if (constant.addonWithCountries.includes(addon.code)) {
      if (constant.addonsCountryList[addon.code]) {
        /* Generating country list HTML */
        const countries = constant.addonsCountryList[addon.code].reduce((acc, country) => {
          return acc + `<li class="icons-img ${country.code.toLowerCase()}-icon" data-country="${country.code}">${country.name}</li>`;
        }, '');

        /* appending country list HTML into country select box */
        const countryDropdownelement = document.querySelectorAll('.cart-box .dropdown-list');
        for (var i = 0; i < countryDropdownelement.length; i++) {
          countryDropdownelement[i].querySelector('.select-option-card ul').innerHTML = countries;
          countryDropdownelement[i].style.display = 'block';
          countryDropdownelement[i].setAttribute('addon-code', addon.code);
        }
      }
    } else {
      addAddon(addon.code);
    }
  }

  /* Special addons */
  if (constant.specialAddonList.includes(addon.code) && preSelectedAddon.includes(addon.code)) {
    addAddon(addon.code);
  }
}

document.addEventListener(
  'click',
  function (e) {
    let target = e.target;
    let dropdownListelement = target.closest('.dropdown-list');
    let selectedAddons = cartState.selected_addons ? cartState.selected_addons : [];

    removeClass('.dropdown-list', 'open');

    /* Addon add button click listner */
    if (target.matches('.selected-option, .selected-option *')) {
      e.stopPropagation();

      dropdownListelement.classList.add('open');
    }

    /* country click listner */
    if (target.matches('.icons-img, .icons-img *')) {
      e.stopPropagation();
      const addonCode = dropdownListelement.getAttribute('addon-code');
      const addonCountry = target.getAttribute('data-country');

      const countryDropdownelement = document.querySelectorAll('.country-select-op');
      for (var i = 0; i < countryDropdownelement.length; i++) {
        countryDropdownelement[i].innerText = target.innerText;
      }

      if (selectedAddons.includes(addonCode)) {
        removeAddon(addonCode);
      }

      addAddon(addonCode, addonCountry);
    }
  },
  true,
);

/* User information input fields */
let paymentForm = document.querySelector('#payment-form');
paymentForm.addEventListener('keyup', function (e) {
  let target = e.target;
  e.stopPropagation();

  if (target.matches('#input_name,#input_email,#input_password')) {
    if (target.value) fieldsValidation(target);
    removeInputError(target);
  }
});

paymentForm.addEventListener('focusout', function (e) {
  let target = e.target;
  e.stopPropagation();

  if (target.matches('#input_name,#input_email,#input_password') && target.value) {
    const isValid = fieldsValidation(target);
    if (target.matches('#input_email') && isValid) {
      let correctDomain = gmailDomainCorrection(target.value);
      if (correctDomain) {
        target.value = correctDomain;
      }
    }
    if (window.isPaymentInfoEventSent === false && target.matches('#input_email') && isValid) {
      //send payment info event into GA4
      sendGa4CustomEvent('signup_email_push', {email: target.value});
      GA4addPaymentInfoEvent();
    }
  }

  if (target.matches('#input_name')) {
    let recurlyFirstNameElement = document.querySelector('[data-recurly="first_name"]');
    let recurlyLastNameElement = document.querySelector('[data-recurly="last_name"]');
    const [firstName, lastName] = splitIntoFirstAndSecondName(target.value);

    recurlyFirstNameElement.value = firstName || 'N/A';
    recurlyLastNameElement.value = lastName || 'N/A';
  }
});

// Cities Accordian
document.addEventListener(
  'click',
  function (e) {
    let target = e?.target;
    let countryListTarget = target?.closest('.country-list');
    let cityList = document?.querySelectorAll('.city-list') || [];
    let currentCity = countryListTarget?.querySelector('.city-list');
    for (var i = 0; i < cityList.length; i++) {
      cityList[i].style.display = 'none';
    }
    if (currentCity) {
      currentCity.style.display = 'block';
    }
  },
  true,
);

/* VAT events */
const allCountries = cartState.all_countries ? cartState.all_countries : [];
const gatewayTaxSummary = document.querySelector('.tax-summary');
const taxSelected = document.querySelector('.tax-selected');
const optionsContainer = document.querySelector('.options-container');
const taxSelectbox = document.querySelector('.tax-selectbox');
const countrySearch = document.querySelector('#country-search');
const selectedCountryHiddenField = $("input[data-recurly='country']");
let selectedOption = document.querySelector('.country-option.option-selected .radio');

if (gatewayTaxSummary) {
  taxSelected.addEventListener('click', e => {
    e.stopPropagation();
    taxSelectbox.classList.toggle('active');
    countrySearch.focus();
  });

  document.addEventListener('click', e => {
    if (e.target !== countrySearch) {
      taxSelectbox.classList.remove('active');
    }
  });

  optionsContainer.addEventListener('click', function (e) {
    let optionElement;

    //TODO: Remove jQuery code
    if ($(e.target).hasClass('country-option')) {
      optionElement = e.target;
    } else {
      optionElement = $(e.target).parent('.country-option')[0];
    }

    if (optionElement) {
      var previous = document.querySelector('.option-selected');
      previous && previous.classList.contains('option-selected') && previous.classList.remove('option-selected');
      selectedOption = optionElement.querySelector('.radio');
      let selectedCountryCode = optionElement.querySelector('.radio').value;
      taxSelected.innerHTML = optionElement.querySelector('label').innerHTML;
      optionElement.className += ' option-selected';
      setState({user_country: selectedCountryCode});
      selectedCountryHiddenField.val(selectedCountryCode);
      taxSelectbox.classList.remove('active');
    }
  });

  countrySearch.addEventListener('keyup', function (e) {
    let res = '';

    allCountries.map(val => {
      if (val.country_name.toLowerCase().indexOf(e.target.value.toLowerCase()) > -1) {
        res += `<div class="country-option ${selectedOption.value == val.iso2 ? 'option-selected' : ''}">
                      <input type="radio" class="radio" id="vat-${val.iso2}" name="Country" value="${val.iso2}">
                      <img loading="lazy" src="https://images.purevpn-tools.com/public/images/tickmark-dropdown.png" alt="" class="img-responsive img-selected">
                      <label for="${val.iso2}">${val.country_name}</label>
                  </div>`;
      }
    });

    optionsContainer.innerHTML = res;
  });
}

/* Cart Tabs */
let tabsWrapper = document.querySelector('.plan-tabs-wrap ul');
tabsWrapper?.addEventListener('click', function (e) {
  let target = e.target;

  if (target.matches('li, li *, span, span *')) {
    e.stopPropagation();

    if (target.matches('span, span *')) {
      target = target.parentElement;
    }

    let tabName = target.getAttribute('data-tabs');
    if (!tabName) {
      target = target.closest('li');
      tabName = target.getAttribute('data-tabs');
    }

    removeClass('.plan-tabs-wrap ul li', 'active');
    target.classList.add('active');

    removeClass('.cart-boxes-wrapper', 'active');
    const currentPlanBox = document.querySelector(`.plan-box-wrapper.${tabName}`);
    if (tabName && currentPlanBox) {
      currentPlanBox.classList.add('active');
    }

    let planIndex = target.getAttribute('data-plan-index');
    planIndex = planIndex.split(',');
    if (planIndex[1]) {
      document.querySelectorAll('[data-plan-index="' + planIndex[1] + '"]').forEach(e => e.click());
    }
  }
});

/* Render Components */
function renderComponents() {
  const OrderSummaryInstance = new OrderSummary();
  OrderSummaryInstance.render();

  const CheckoutFormInstance = new CheckoutForm();
  CheckoutFormInstance.render();

  GpayGateway.loadGooglePayIfApplicable();
  ApplePayGateway.loadApplePayIfApplicable(GatewaysInstance);
}

const GatewaysInstance = new Gateways();
GatewaysInstance.render();

// To generate Packageboxes and Special addons
const productsInstance = new GenerateProducts();
productsInstance.render();

const IncentiveInstance = new Incentive();
IncentiveInstance.render();

const GatewayIncentiveInstance = new GatewayIncentive();
GatewayIncentiveInstance.render();

$('.pro-btn').click(function () {
  $('html,body').animate(
    {
      scrollTop: $('#gateway-for-scroll').offset().top,
    },
    'slow',
  );
});

// payment gateways accordians
document.querySelectorAll('.accordion__heading').forEach(accordian => {
  accordian?.addEventListener('click', function (e) {
    let target = e.target;

    if (target.classList.contains('cart-gateways') || target.classList.contains('cart-svg')) {
      target = target.parentElement;
    } else if (target.classList.contains('svg-path')) {
      target = target.parentElement.parentElement;
    } else if (target.classList.contains('gateway-icon')) {
      target = target.parentElement.parentElement;
    }

    resetPaymentAndIncentive(target);

    const siblingElement = target.nextElementSibling;
    if (!siblingElement.style.display) {
      siblingElement.style.display = `block`;
    } else {
      siblingElement.style.display = null;
    }

    target.classList.toggle('accordion__heading-active');
    siblingElement.classList.toggle('accodrion__content-show');
  });
});
